<div class="form-group">
  @if (showLabel && question?.question_copy) {
    <label [innerHtml]="question?.question_copy" class="form-group__label"></label>
  }
  @if (showSkip) {
    <div class="question-skip">
      <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
        <input
          type="checkbox"
          [checked]="skipped"
          [(ngModel)]="skipped"
          (ngModelChange)="onSkipChange()"
          name="add-note-toggle"
          id="skip-driver-details-toggle">
          <span class="custom-toggle__indi"></span>
          <span class="custom-toggle__label">Skip for now</span>
        </label>
      </div>
    }
    <div class="card timepicker" [ngClass]="{'no-shadow' : noShadow}">
      <div class="timepicker__input-container">
        <input class="form-control" placeholder="00" type="number" [(ngModel)]="hour" name="hour" [min]="minHour" [max]="maxHour" step="1"
          (blur)="onBlur($event)"  />
          <span class="timepicker__separator">:</span>
          <input class="form-control" placeholder="00" type="number" [(ngModel)]="minute" name="minute" [min]="minMinute" [max]="maxMinute" step="1"
            (blur)="onBlur($event)"/>
          </div>
          <div class="timepicker__toggle-container">
            @for (item of ampm; track item) {
              <label class="timepicker__toggle">
                <input [checked]="item.checked" type="radio" [id]="item?.id" (change)="onChange(item)"
                  [name]="'ampm-radio-' + item.id" [value]="item.value"  [attr.disabled]="item.disabled ? '' : null" />
                  <span class="timepicker__toggle__label">{{item.value}}</span>
                </label>
              }
            </div>
          </div>
        </div>